"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SHARED_DOCUMENT_SIZE = exports.sharedDocumentReadStatuses = exports.sharedDocumentScopeTypes = exports.sharedDocumentAudiences = void 0;
const doctor_substitute_document_1 = require("../doctor-substitutes/doctor-substitute-document");
/**
 * The profiles a shared document can be written for. A document reaches
 * exactly one of them; reaching two means publishing two documents.
 *
 * Each audience is spelled as the user role it addresses (checked by
 * `satisfies`), so a reader's role names the only audience they can be part of.
 */
exports.sharedDocumentAudiences = [
    'substitute_doctor',
    'attending_doctor',
    'medical_assistant',
];
/**
 * How a shared document's targets are expressed: whole sites, offices, or
 * named people. Exactly one per document.
 */
exports.sharedDocumentScopeTypes = ['sites', 'offices', 'people'];
/**
 * Where a recipient stands with a shared document: never opened (`unread`),
 * opened with no confirmation asked (`read`), opened but a mandatory read not
 * yet confirmed (`to_confirm`), or confirmed (`confirmed`).
 */
exports.sharedDocumentReadStatuses = [
    'unread',
    'read',
    'to_confirm',
    'confirmed',
];
/**
 * Max size of a shared document (10 MB) — the same limit as a substitute's
 * supporting documents, so both uploads behave alike.
 */
exports.MAX_SHARED_DOCUMENT_SIZE = doctor_substitute_document_1.MAX_DOCTOR_SUBSTITUTE_DOCUMENT_SIZE;
